var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import 'reflect-metadata';
import { Component, Prop, Vue } from 'vue-property-decorator';
var isAphaNumericWithSpace = require("../../../lib/validate").isAphaNumericWithSpace;
import ExtendModal from "@/components/ExtendModal.vue";
import InputV2 from "@/components/inputv2.vue";
import Button from "@/components/button.vue";
import { namespace } from 'vuex-class';
var Store = namespace('ts');
var Account = /** @class */ (function (_super) {
    __extends(Account, _super);
    function Account() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '';
        _this.nameError = '';
        _this.isPrimary = false;
        _this.error = '';
        _this.buttonName = 'Create';
        _this.editable = null;
        return _this;
    }
    Account.prototype.mounted = function () {
        if (this.reserved) {
            this.editable = this.reserved;
            this.name = this.editable.account_name;
            this.isPrimary = Boolean(this.editable.is_primary);
            this.buttonName = 'Rename Account';
        }
    };
    Account.prototype.togglePrimary = function () {
        this.isPrimary = !this.isPrimary;
    };
    Account.prototype.validate = function (value) {
        this.nameError = !isAphaNumericWithSpace(value) ? 'Special characters not allowed' : '';
    };
    Account.prototype.submitForm = function () {
        var _this = this;
        this.createReserve({ name: this.name, isPrimary: this.isPrimary, account_id: this.editable ? this.editable.id : null });
        setTimeout(function () {
            _this.toggle();
        }, 3000);
    };
    __decorate([
        Prop()
    ], Account.prototype, "toggle", void 0);
    __decorate([
        Prop()
    ], Account.prototype, "reserved", void 0);
    __decorate([
        Store.Action
    ], Account.prototype, "createReserve", void 0);
    __decorate([
        Store.Action
    ], Account.prototype, "updateReserve", void 0);
    __decorate([
        Store.Getter
    ], Account.prototype, "getCreateReserve", void 0);
    Account = __decorate([
        Component({
            name: 'CreateReservedAccount',
            components: { ExtendModal: ExtendModal, InputV2: InputV2, Button: Button }
        })
    ], Account);
    return Account;
}(Vue));
export default Account;
